const COUNTRY_NAMES = { AU: "Australia", NZ: "New Zealand", US: "United States", GB: "United Kingdom", CA: "Canada", SG: "Singapore", FJ: "Fiji", PG: "Papua New Guinea" };

const trim = (s, n) => {
  if (!s || s.length <= n) return s || "";
  const cut = s.slice(0, n - 1);
  const atWord = cut.lastIndexOf(" ");
  return `${(atWord > n * 0.6 ? cut.slice(0, atWord) : cut).replace(/[\s,—-]+$/, "")}…`;
};

// Drop trailing segments (location, then category) before ever cutting a word.
const fitTitle = (parts, n) => {
  for (let i = parts.length; i > 0; i -= 1) {
    const t = parts.slice(0, i).join(" — ");
    if (t.length <= n) return t;
  }
  return trim(parts[0], n);
};

export function listingLocation(item) {
  const country = item.country || COUNTRY_NAMES[item.country_code] || item.country_code || "";
  return [item.city, country].filter(Boolean).join(", ");
}

// Unique title/description per supplier listing: "{Company} — {Category} supplier in {Location}"
export function listingSeo(item) {
  const company = item.company || item.advertiser?.company || item.advertiser_name || item.title || "Supplier";
  const category = item.category?.name || "";
  const location = listingLocation(item);
  const titleParts = [company, category ? `${category} Supplier` : null, location].filter(Boolean);
  const title = fitTitle(titleParts, 70);
  const isPaid = item.tier && item.tier !== "free";
  const lead = `${company}${category ? ` is a ${category.toLowerCase()} supplier` : ""}${location ? ` based in ${location}` : ""}, listed on Accommodation Suppliers`;
  const tail = isPaid
    ? " — the B2B directory for hotels, resorts and accommodation groups. View products and request a quote."
    : " — the B2B directory for hotels, resorts and accommodation groups. View the company profile.";
  const description = trim(`${lead}${tail}${item.description ? ` ${item.description}` : ""}`, 158);
  const image = item.image_url || item.gallery?.[0] || item.logo_url || undefined;
  return { title, description, image: image && /^https?:\/\//.test(image) ? image : undefined, path: `/listing/${item.slug || item.id}` };
}

// Category page: mentions the category + Accommodation Suppliers; state/country filters get their own variant.
export function categorySeo(cat, { stateLabel, countryLabel, total } = {}) {
  const region = stateLabel || countryLabel || "";
  const name = cat.name;
  const title = trim(region ? `${name} Suppliers in ${region}` : `${name} Suppliers for Hotels & Accommodation`, 60);
  const count = `Compare ${name.toLowerCase()} suppliers`;
  const description = trim(
    `${count}${region ? ` serving ${region}` : ""} on Accommodation Suppliers — the B2B directory where hotels, resorts and accommodation groups source verified suppliers and request quotes.${cat.description ? ` ${cat.description}` : ""}`,
    158,
  );
  return { title, description, path: `/category/${cat.slug || cat.id}` };
}
